import type { ExchangeBetslipSettings } from "./ExchangeSettings.types";

export const BETSLIP__EXC_SETTINGS_RECEIVED = "BETSLIP/EXC_SETTINGS_RECEIVED";

export type ExchangeSettingsReceivedAction = {
  type: typeof BETSLIP__EXC_SETTINGS_RECEIVED;
  payload: ExchangeBetslipSettings;
};
